import { Component } from '@angular/core';

@Component({
  selector: 'uni-form-fields',
  templateUrl: './uni-form-fields.component.html',
  styleUrls: ['./uni-form-fields.component.scss']
})
export class UniFormFieldsComponent { }
